import React from "react";

function Questionnaire({ clientId }) {
  return (
    <div>
      <h3>Questionnaire</h3>
      <p>Client sélectionné ID : {clientId}</p>

      {/* Contenu Questionnaire ici */}
    </div>
  );
}

export default Questionnaire;
